<template>
  <div class="property_wrap formedit">
    <div class="pro_top">上传图片设置</div>
    <div class="pro_con">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="提示语:">
          <el-input v-model="property.name" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="图片数量限制:">
          <el-input type="text" v-model="property.num" max-length="2"></el-input>
         <template slot="append">张</template>
        </el-form-item>
        <el-form-item label="设置:">
          <el-checkbox v-model="property.checked">设为必填项</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
      form: {}
    };
  }
};
</script>

 